// @ts-nocheck

import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

import { externalLinkOpen } from '../../actions/externallink';
import useMergeProps from '../../hooks/useMergeProps';
import useRouter from '../../hooks/useRouter';
import useOpenBoomView from '../../modules/boom/hooks/useOpenBoomView';
import useOpenGRView from '../../modules/gift-race/hooks/useOpenGRView';
import { ZIndices } from '../../styled-components/dark/common';

import NavigationBar from './NavigationBar';
import { type NavigationBarPropsType } from './NavigationBar';
import selectNavigationBarProps from './NavigationBar.selector';

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: ${ZIndices.navBar};
  width: 100%;
  background-color: #000;
  display: flex;
  justify-content: space-between;
  transform: translateY(0);
  align-items: center;

  height: var(--navbar-height);

  padding-top: constant(safe-area-inset-top);
  padding-top: env(safe-area-inset-top);
  padding-left: constant(safe-area-inset-left);
  padding-left: env(safe-area-inset-left);
  padding-right: constant(safe-area-inset-right);
  padding-right: env(safe-area-inset-right);
  font-family: 'BettingArchivoNarrow' !important;

  & > div {
    opacity: ${({ $disable }) => ($disable ? 0.3 : 1)};
    pointer-events: ${({ $disable }) => ($disable ? 'none' : 'auto')};
  }
`;

const NavigationBarWrapper = ({ isWinModalOpen, ...rest }: NavigationBarPropsType & { isWinModalOpen: boolean }) => {
  return (
    <Wrapper $disable={isWinModalOpen}>
      <NavigationBar {...rest} />
    </Wrapper>
  );
};

type PropsType = {
  toggleMenu: () => void;
  className?: string;
};

const NavigationBarContainer = ({ toggleMenu, ...ownProps }: PropsType) => {
  const { history, location } = useRouter();
  const dispatch = useDispatch();
  const openGRView = useOpenGRView();
  const openBoomView = useOpenBoomView();

  const openExternalLink = useCallback(
    (url, options) => {
      dispatch(externalLinkOpen(url, options));
    },
    [dispatch],
  );

  const selectorProps = useMemo(
    () => ({
      history,
      location,
      toggleMenu,
      dispatch,
      openExternalLink,
      openGRView,
      openBoomView,
    }),
    [dispatch, history, location, openExternalLink, openGRView, openBoomView, toggleMenu],
  );

  const selectedProps = useSelector((state) => selectNavigationBarProps(state, selectorProps));

  const enhancedProps: NavigationBarPropsType & { isWinModalOpen: boolean } = useMergeProps({
    ownProps,
    selectedProps,
  });

  return <NavigationBarWrapper {...enhancedProps} />;
};

export default NavigationBarContainer;
